export default {
    get token() {
        return localStorage.getItem('token')
    },
    set token(token) {
        localStorage.setItem('token', token)
    }
}

